import s from '../pages.scss';
import {
  SkeletonLine,
  SkeletonRectangle,
  Box,
  SkeletonGroup,
  Page,
} from '@wix/design-system';
import React from 'react';
import { useRouterContext } from '../../contexts';
import type { RoutePath, RoutePayloadMap } from '../../models';
import { AppsSectionSkeleton } from '../../components/apps-section/apps-section-skeletons';

export function CollectionSkeleton() {
  const { route } = useRouterContext();

  const isSaleCollection =
    (route.payload as RoutePayloadMap[RoutePath.COLLECTION]).slug ===
    'holiday-sale';

  return (
    <Page className={`${s.appMarketPage} ${s.appMarketPageBackgroundColor}`}>
      <Page.Content>
        <SkeletonGroup skin="light">
          <Box dataHook="skeleton-header" marginTop="24px" direction="vertical">
            <Box dataHook="back-button-skeleton" marginLeft="4px">
              <SkeletonLine width="50px" />
            </Box>
            <Box
              dataHook="skeleton-titles"
              marginTop="20px"
              direction="vertical"
            >
              <SkeletonRectangle width="175px" height="18px" />
              <SkeletonRectangle width="638px" height="30px" marginTop="6px" />
              <SkeletonLine width="540px" marginTop="12px" />
              <SkeletonLine width="264px" marginTop="4px" />
            </Box>
          </Box>
          <AppsSectionSkeleton showSaleToggle={!isSaleCollection} />
        </SkeletonGroup>
      </Page.Content>
    </Page>
  );
}
